// extracted by mini-css-extract-plugin
export default {"Download":"Wny5LfnRK_0tCpE1WG2c"};